import { ToastController } from '@ionic/angular';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { FrontendConfiguration } from '../../../configuration/config.patientportal.test';
import { ErrorHandlingService } from './error-handling-service';

export function errorHandlerFactory(toastController: ToastController) {
    const config = new FrontendConfiguration();
    if (
        config.appInsightsConnectionString !== null &&
        config.appInsightsConnectionString !== undefined &&
        config.appInsightsConnectionString !== '' &&
        config.appInsightsConnectionString !== '$appInsight'
    ) {
        return new ApplicationinsightsAngularpluginErrorService();
    } else {
        return new ErrorHandlingService(toastController);
    }
}
